import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Image,
    Select,
    Box,
    Flex,
    Text,Button,SimpleGrid,
    Textarea,
    TableContainer,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableCaption,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useToast
  } from "@chakra-ui/react";
  import { useSelector } from "react-redux";
  
  import { Card, CardHeader, CardBody, CardFooter } from '@chakra-ui/react'
  import { useRef } from "react";
  import { useReactToPrint } from "react-to-print";
  
  import axios from 'axios'
  
  import React, { useState,useEffect } from "react";
  import toast from "react-hot-toast";

import { useLocation } from "react-router-dom";
  const array = [
    "Malda",
    "Uttar Dinajpur",
    "Dakshin Dinajpur",
    "Murshidabad",
    "Birbhum",
    "Hoogly",
    "Paschim Bardhaman",
    "Purba Bardhaman",
    "Alipurduar",
    "Cooch Behar",
    "Darjeeling",
    "Jalipaiguri",
    "Kalingpong",
    "Howrah",
    "Kolkata",
    "Nadia",
    "North 24 Pargana",
    "South 24 Pargana",
    "Bankura",
    "Jhargram",
    "Purulia",
    "Purba Medinipur",
    "Paschim Medinipur",
  ];
  
  let fiterArray = array.sort((a, b) => {
    return a.localeCompare(b);
  });
  
  //console.log(fiterArray);
  const OtherRoomRate = () => {
  
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    const customerId=localStorage.getItem('customerId')

    const token=localStorage.getItem('token');
    const [data,setData]=useState([])
    const [printData,setPrintData]=useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [editItemId, setEditItemId] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const cancelRef = useRef();
    const [formData, setFormData] = useState({
      category: "",
    singleRoomRate:0,
    doubleRoomRate:0,
    extraPersonRate:0,
    breakfastRate:0,
    breakfastwithLunchAndDinnerRate:0,
    breakfastwithLunchRate:0,
    breakfastwithDinnerRate:0

    
      
    });
   
 

  //const customerId=localStorage.getItem('customerId');

  const fetchData3 = async () => {
    try {
      const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getPrintData/${customerId}`);
      const rooms = response.data;
  
      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(`https://api.hotel.tdrsoftware.in/get-image/${room.image}`, {
              responseType: 'blob', // Assuming image is returned as a blob
            });
  
            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        })
      );
  
      console.log(updatedRooms, 'updatedRooms');
      setPrintData(updatedRooms);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchData=async()=>{
    try {
      const response=await axios.get(`https://api.hotel.tdrsoftware.in/api/getOtherRoomRate/${customerId}`)
      setData(response.data.otherRoomRate)
      console.log(response.data.otherRoomRate)
    } catch (error) {
      toast.error(error.message)
    }
  }
const edit=(item)=>{
  setIsEditing(true)
  setEditItemId(item._id)
  setFormData({
    category: item.category,
    singleRoomRate:item.singleRoomRate,
    doubleRoomRate:item.doubleRoomRate,
    extraPersonRate:item.extraPersonRate,
    breakfastRate:item.breakfastRate,
    breakfastwithLunchAndDinnerRate:item.breakfastwithLunchAndDinnerRate,
    breakfastwithLunchRate:item.breakfastwithLunchRate,
    breakfastwithDinnerRate:item.breakfastwithDinnerRate
  })
}
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };

useEffect(()=>{
  fetchData()
  fetchData3()
},[customerId])
let room=printData?.map((item)=>item.roomType);
const roomTypes = room[0]?.split(',')?.map(item => item.trim());

  
    const validateForm = () => {
      const requiredFields = [
        "category",
        
        
        
     
        
      ];
  
      for (const field of requiredFields) {
        if (!formData[field]) {
          return false;
        }
      }
      return true;
    };
//  const handleSubmit=async(e)=>{
//     e.preventDefault();
//     if(!validateForm()) {
//       toast.error("Please fill in all required fields.");
//       return;
//     }
//     setFormData({
//         name:formData.name,
//         address:formData.address,
//         phoneNo:formData.phoneNo,
//         gstIn:formData.gstIn,
//         openingBalance:formData.openingBalance,
//     })

//  }

    const save=async(e)=>{
        e.preventDefault();
        if(!validateForm()) {
          toast.error("Please fill in all required fields.");
          return;
        }
        try{
       if(isEditing){
        
          const response=await axios.put(`https://api.hotel.tdrsoftware.in/api/updateOtherRoomRate/${customerId}/${editItemId}`,{data:formData})
          toast.success(response.data.message)
          setIsEditing(false)
          setEditItemId(null)
          
        
       }else{
        const response=await axios.post("https://api.hotel.tdrsoftware.in/api/addOtherRoomRate",{
          customerId:customerId,data:formData
        });
       // console.log('Data Submitted: ',response.data);
        
        toast.success(response.data.message)
      }
        setFormData({
          category: "",
    singleRoomRate:0,
    doubleRoomRate:0,
    extraPersonRate:0,
    breakfastRate:0,
    breakfastwithLunchAndDinnerRate:0,
    breakfastwithLunchRate:0,
    breakfastwithDinnerRate:0
        })
        fetchData()

      }catch(error){
        toast.error(error.meesage)
      }
    }
  //  console.log(formData,'formdata');
    
   // console.log(arr)
   
    //console.log(newObj);
   
    const openModal = (id) => {
      setDeleteItemId(id);
      setIsOpen(true);
    };
  
    const onClose = () => {
      setIsOpen(false);
      setDeleteItemId(null);
    };
    const handleDelete=async()=>{
     
      try {
        const response=await axios.delete(`https://api.hotel.tdrsoftware.in/api/deleteOtherRoomRate/${customerId}/${deleteItemId}`)
        toast.success(response.data.message)
        setIsOpen(false)
        setDeleteItemId(null)
        fetchData()
      } catch (error) {
        toast.error(error.message)
      }
    }
    
    // due=total-advance
    return (
      <Box   bg='#EAE5DF '
      columns={{ sm: 2, md: 4 }}
      spacing='8'
      p='10'
      textAlign='center'
      
      
      color='black' width='100%'    >
      <Text fontSize='2xl' fontWeight='bold' textAlign='center' color='black' mb={10}>Other Rates</Text>
        
        <FormControl isRequired onSubmit={save}>
          <Box display="grid"  gridGap={1} >
        
            
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel fontSize='sm'>Category</FormLabel>
                <Select size='sm' w='74%'  bg='#FAFAFA ' placeholder="Enter Category" name='category' value={formData.category} onChange={handleInputChange}>
                   {roomTypes?.map((item)=>( <option value={item}>{item}</option>))}
                    
                </Select>
              </Box>
             
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel fontSize='sm'>SingleRoomRate</FormLabel>
                <Input size='sm' w='55%' bg='#FAFAFA ' placeholder="Enter Single Rate" name='singleRoomRate' value={formData.singleRoomRate} onChange={handleInputChange}/>
              </Box>
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel fontSize='sm'>Double Room Rate</FormLabel>
                <Input size='sm' w='60%' bg='#FAFAFA ' placeholder="Enter Double Rate" name='doubleRoomRate' value={formData.doubleRoomRate} onChange={handleInputChange}/>
              </Box>
              </Box>
              <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel fontSize='sm'>Extra Person</FormLabel>
                <Input size='sm' w='74%'  bg='#FAFAFA ' placeholder="Enter Extra Person" name='extraPersonRate' value={formData.extraPersonRate} onChange={handleInputChange}/>
                    
              </Box>
             
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel fontSize='sm'>Breakfast(CP) Rate</FormLabel>
                <Input size='sm' w='65%' bg='#FAFAFA ' placeholder="Enter Breakfast Rate" name='breakfastRate' value={formData.breakfastRate} onChange={handleInputChange}/>
              </Box>
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel fontSize='sm'>Breakfast/Lunch/Dinner(AP) Rate</FormLabel>
                <Input size='sm' w='71%' bg='#FAFAFA ' placeholder="Breakfast Lunch Dinner Rate" name='breakfastwithLunchAndDinnerRate' value={formData.breakfastwithLunchAndDinnerRate} onChange={handleInputChange}/>
              </Box>
              </Box>
              <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
              <Box width="50%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel fontSize='sm'>Breakfast-Lunch/Breakfast-Dinner(MAP) Rate</FormLabel>
                <Input size='sm' w='60%'  bg='#FAFAFA ' placeholder="Enter Breakfast Lunch" name='breakfastwithLunchRate' value={formData.breakfastwithLunchRate} onChange={handleInputChange}/>
                    
              </Box>
             
              {/* <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel fontSize='sm'>Breakfast Dinner Rate</FormLabel>
                <Input size='sm' w='65%' bg='#FAFAFA ' placeholder="Breakfast Dinner Rate" name='breakfastwithDinnerRate' value={formData.breakfastwithDinnerRate} onChange={handleInputChange}/>
              </Box> */}
              
              </Box>
              
             
            
            
            
            
            
              
             
           
          
          </Box>
         
          {/* <Button type="submit" variant='solid' color='#0F172B' mr={3} bg='#FEA116' _hover={{color:'white'}} mt={5} onClick={handleSubmit}>Cash Bill</Button> */}
          <Button type="submit" variant='solid' color='#0F172B' bg='#FEA116' _hover={{color:'white'}} mt={5} onClick={save}>{isEditing ? "Update" : "Save"}</Button>
         
        </FormControl>
        <TableContainer width='full' mt={10} border='1px solid black' p={4} bg='white' borderRadius='10px' fontSize='sm'>
                <Table size='sm' variant='striped' colorScheme='teal'>
                    <TableCaption>Rate Data</TableCaption>
                    <Thead>
                        <Tr >
                            <Th >Category</Th>
                            <Th>Single Person Rate</Th>
                            <Th>Double Person Rate</Th>
                            <Th>Extra Person Rate</Th>
                            <Th>Breakfast Rate(CP)</Th>
                            <Th>Breakfast/Lunch/Dinner(AP) Rate</Th>
                            <Th>Breakfast-Lunch/Breakfast-Dinner(MAP)  Rate</Th>
                           
                            
                            
                            <Th>Edit</Th>
                            <Th>Delete</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data.map((item, index) => (
                            <Tr key={index}>
                                <Td>{item.category}</Td>
                                <Td>{item.singleRoomRate}</Td>
                                <Td>{item.doubleRoomRate}</Td>
                                <Td>{item.extraPersonRate}</Td>
                                <Td>{item.breakfastRate}</Td>
                                <Td>{item.breakfastwithLunchAndDinnerRate}</Td>
                                <Td>{item.breakfastwithLunchRate}</Td>
                                
                               
                                
                                
                                <Td><Button colorScheme="green" size="sm" onClick={() => edit(item)}>Edit</Button></Td>
                                <Td><Button colorScheme="red" size="sm" onClick={() => openModal(item._id)}>Delete</Button></Td>

                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>Are you sure you want to delete this item?</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      
      
        
      </Box>
    );
  };
  
  export default OtherRoomRate;
  